module.exports = global["jQuery"] = require("-!/Users/mkramer/Code/masondotnet/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 78
// module chunks = 0